import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, COMBO_BOX, AUTO_COMPLETE} = FIELD_TYPE;

const fieldsPatient: DataFormField[] = [
  {
    type: DATE,
    label: "Ngày tạo",
    placeholder: "Nhập...",
    name: "ngayTao",
    optionsTime: {showTime: true, format: FORMAT_TIME.dateTime},
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    placeholder: "Nhập...",
    name: "dienThoai",
    disable: true,
  },

  {
    type: INPUT,
    label: "Địa chỉ",
    placeholder: "Nhập",
    name: "diaChiTongHop",
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Loại KCB",
    placeholder: "Nhập",
    name: "loaiKCB",
    disable: true,
  },
  {
    type: INPUT,
    label: "Lý do khám",
    name: "lyDoKham",
    disable: true,
  },
  {
    type: INPUT,
    label: "Thân nhân",
    placeholder: "Nhập",
    name: "thanNhan",
    disable: true,
  },
  {
    type: INPUT,
    label: "Bác sĩ chỉ định",
    placeholder: "Nhập",
    name: "bacSyChiDinh",
    disable: true,
  },
  {
    type: INPUT,
    label: "Chẩn đoán",
    placeholder: "",
    name: "chanDoan",
    disable: true,
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái XN",
    placeholder: "Nhập",
    name: "trangThai",
    disable: true,
    options: [
      {
        value: 0,
        label: "Phiếu Khám Mới",
      },
      {
        value: 1,
        label: "Chờ Thực Hiện",
      },
      {
        value: 2,
        label: "Đang Thực Hiện",
      },
      {
        value: 3,
        label: "Hoàn Thành",
      },
      {
        value: 4,
        label: "Chờ kết quả xét nghiệm",
      },
      {
        value: 5,
        label: "Đã có kết quả xét nghiệm",
      },
      {
        value: 6,
        label: "Hủy thực hiện",
      },
      {
        value: 7,
        label: "Đã xóa",
      },
    ],
  },
  {
    type: AUTO_COMPLETE,
    label: "NV thực hiện",
    placeholder: "Nhập",
    name: "nvThucHien",
    options: [
      {
        value: "Đậu Trung Hiếu",
      },
      {
        value: "Nguyễn Thị Hồng Thắm",
      },
    ],
  },
  {
    type: DATE,
    label: "TG chỉ định",
    // placeholder: "thoiGianChiDinh",
    name: "thoiGianChiDinh",
    // css: {
    //   xl: 16,
    //   lg: 12,
    //   md: 24,
    //   sm: 24,
    //   xs: 24,
    // },
    optionsTime: {showTime: true, format: FORMAT_TIME.dateTime},
    // labelCol: {xs: 10, md: 8, lg: 8, xl: 3},
    // wrapperCol: {xs: 14, md: 16, lg: 16, xl: 21},
    disable: true,
  },
  {
    type: AUTO_COMPLETE,
    label: "Trưởng khoa XN",
    placeholder: "Nhập",
    name: "truongKhoaXetNghiem",
    options: [
      {
        value: "Đậu Trung Hiếu",
      },
      {
        value: "Nguyễn Thị Hồng Thắm",
      },
    ],
  },
  {
    type: INPUT,
    label: "Ghi chú",
    placeholder: "Nhập",
    name: "ghiChu",
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: {xs: 8, md: 6, lg: 6, xl: 2},
    wrapperCol: {xs: 16, md: 18, lg: 18, xl: 22},
  },
];
export {fieldsPatient};
